import React from "react";
import { Link } from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import CreateNewJObModal from "../CreateJobModal/NewJobModal";
import "./create-new-job-card.style.scss";
const CreateNewJObCard = () => {
  const [openBasicModal, setOpenBasicModal] = React.useState(false);
  return (
    <div className="job-posted-card-main">
      <div className="create-jpcm-header">
        <img src={Images.addJobIcon} />
      </div>
      {openBasicModal && (
        <CreateNewJObModal closeIt={() => setOpenBasicModal(false)} />
      )}
      <h5 className="create-job-title">CREATE A JOB POST</h5>
      <p className="create-job-institute-name">you can create up to</p>
      <p className="create-job-institute-name create-job-institute-second-name">
        <span>3 new</span> job posts.
      </p>
      <button className="apply-button" onClick={() => setOpenBasicModal(true)}>
        <Link>Create Job</Link>
      </button>
    </div>
  );
};
export default CreateNewJObCard;
